import { PRIVACY_NOTICE, SAAS_SERVICES_AGREEMENT } from "@/constants/routes";
import { FC } from "react";
import { Text } from "../Text";

export type DisclaimerTextProps = {
  type: 'trial' | 'demo';
}

const AiSupplementalTermsLink = () => {
  return (
    <a href="legal/supplemental-terms#ai_features_terms" target="_blank" rel="noreferrer" className="text-primary underline">
      AI Supplemental Terms
    </a>
  );
};

const GeneralTermsLink: FC<{ text: string }> = ({ text }) => {
  return (
    <a href={SAAS_SERVICES_AGREEMENT} target="_blank" rel="noreferrer" className="text-primary underline">
      {text}
    </a>
  );
};

const PrivacyNoticeLink = () => {
  return (
    <a href={PRIVACY_NOTICE} target="_blank" className="text-primary underline">
      Privacy Notice
    </a>
  );
};

const TrialDisclaimer = () => {
  return (
    <Text as="p" type="caption2" className="text-secondary">
      By signing up, I acknowledge that I have read and agreed to the{' '}
      <GeneralTermsLink text="General Terms" />
      {', '}
      <AiSupplementalTermsLink />
      {', and '}
      <PrivacyNoticeLink />
      .
    </Text>
  );
};

const DemoDisclaimer = () => {
  return (
    <Text as="p" type="caption2" className="text-secondary">
      By clicking &ldquo;Continue&rdquo;, I acknowledge I have read and agreed to FrontApp, Inc.’s{' '}
      <GeneralTermsLink text="Terms" />
      {' and '}
      <PrivacyNoticeLink />
      .
    </Text>
  );
};

export const DisclaimerText: FC<DisclaimerTextProps> = ({ type }) => {
  return (
    type === 'trial' ? <TrialDisclaimer /> : <DemoDisclaimer />
  );
};
